module.exports = __webpack_public_path__ + "img/cash.ca3edde9.svg";